import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { authStateAtom } from '@/stores/auth';
import { getCasbinEnforcer } from '@/lib/casbin/enforcer';

export function usePermissions() {
  const { user } = useAtomValue(authStateAtom);

  const hasPermission = useMemo(
    () => async (resource: string, action: string): Promise<boolean> => {
      if (!user) return false;

      const enforcer = await getCasbinEnforcer();
      return enforcer.hasPermission(user.role, resource, action);
    },
    [user]
  );

  const can = useMemo(
    () => (permission: string): boolean => {
      if (!user) return false;
      return user.permissions.includes(permission);
    },
    [user]
  );

  const isRole = useMemo(
    () => (role: string): boolean => {
      if (!user) return false;
      return user.role === role;
    },
    [user]
  );

  const hasAnyRole = useMemo(
    () => (roles: string[]): boolean => {
      if (!user) return false;
      return roles.includes(user.role);
    },
    [user]
  );

  return {
    hasPermission,
    can,
    isRole,
    hasAnyRole,
    userRole: user?.role,
    permissions: user?.permissions || [],
  };
}
